module.exports = __webpack_public_path__ + "static/media/image_placeholder_350_350.27ea510f.png";